import { useFormContext } from "react-hook-form";

import Banner from "ds/components/Banner";
import Button from "ds/components/Button";
import FeedbackActions from "ds/components/Feedback/Actions";
import useTypedFlags from "hooks/useTypedFlags";
import { TerraformWorkflowTool } from "types/generated";

import { StackVendorFormFields } from "../../types";

const TITLE = "Native OpenTofu vendor is available";

type NewStackVendorTerraformOpenTofuDeprecationBannerProps = {
  onSwitchToOpenTofu: () => void;
};

const NewStackVendorTerraformOpenTofuDeprecationBanner = ({
  onSwitchToOpenTofu,
}: NewStackVendorTerraformOpenTofuDeprecationBannerProps) => {
  const { opentofuBackend } = useTypedFlags();
  const { watch } = useFormContext<StackVendorFormFields>();
  const workflowTool = watch("terraform.workflowTool");

  if (!opentofuBackend || workflowTool !== TerraformWorkflowTool.OpenTofu) {
    return null;
  }

  return (
    <Banner variant="info" title={TITLE} announce={TITLE}>
      Native OpenTofu stacks show you more about every run: downloadable CPU profiles for slow runs,
      structured JSON logs and shorter plan and apply output. Deeper run visibility and diagnostics
      arrive soon, only on native stacks.
      <FeedbackActions>
        <Button variant="secondary" size="small" onPress={onSwitchToOpenTofu}>
          Switch to OpenTofu
        </Button>
      </FeedbackActions>
    </Banner>
  );
};

export default NewStackVendorTerraformOpenTofuDeprecationBanner;
